import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-link-icon',
  templateUrl: 'link-icon.component.html'
})
export class LinkIconComponent {
  constructor() {}
}
